import axios from 'axios';
import qs from 'query-string';
import {
  Auth0ResetClient,
  Auth0ResetConfig,
  ResetPasswordResult
} from './auth0';

/**
 * Vistaprint Auth0 reset email client
 *
 * @export
 * @class VpAuth0ResetClient
 * @implements {Auth0ResetClient}
 */
export class VpAuth0ResetClient implements Auth0ResetClient {
  /**
   * Auth0 configuration
   *
   * @property
   * @private
   * @type {Auth0ResetConfig}
   * @memberof VpAuth0ResetClient
   */
  private config: Auth0ResetConfig;

  constructor(config: Auth0ResetConfig) {
    this.config = config;
  }

  private requestUrlEncodedConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };

  async resetPassword(password: string): Promise<ResetPasswordResult> {
    const requestBody = {
      newPassword: password,
      confirmNewPassword: password,
      _csrf: this.config.csrfToken,
      ticket: this.config.ticket
    };

    try {
      await axios.post(
        this.config.resetEmailEndpoint,
        qs.stringify(requestBody),
        this.requestUrlEncodedConfig
      );

      return ResetPasswordResult.success;
    } catch (e) {
      return ResetPasswordResult.fail;
    }
  }

  async resendResetEmail(email: string): Promise<void> {
    const requestBody = {
      email,
      connection: this.config.connection
    };

    try {
      await axios.post(
        this.config.resendResetEmailEndpoint,
        qs.stringify(requestBody),
        this.requestUrlEncodedConfig
      );
    } catch (e) {
      console.error('Reset email request failed.');
    }
  }
}
